"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var More = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.5,17 C13.329,17 14,17.672 14,18.5 C14,19.328 13.329,20 12.5,20 C11.671,20 11,19.328 11,18.5 C11,17.672 11.671,17 12.5,17 Z M12.5,11 C13.329,11 14,11.672 14,12.5 C14,13.328 13.329,14 12.5,14 C11.671,14 11,13.328 11,12.5 C11,11.672 11.671,11 12.5,11 Z M12.5,5 C13.329,5 14,5.672 14,6.5 C14,7.328 13.329,8 12.5,8 C11.671,8 11,7.328 11,6.5 C11,5.672 11.671,5 12.5,5 Z", fillRule: "evenodd" })));
};
More.displayName = 'More';
exports.default = More;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=More.js.map